import { io, Socket } from "socket.io-client";

let socket: Socket | null = null;

export const initSocket = (token: string): Socket => {
    if (!socket) {
        socket = io(process.env.REACT_APP_API_URL as string, {
            auth: {
                token,
            },
            transports: ["websocket"],
            reconnection: true,
            reconnectionDelay: 1000,
        });

        socket.on("connect", () => {
            console.log("✅ Socket connected:", socket?.id);
        });
      
        socket.on("disconnect", (reason) => {
            console.warn("⚠️ Socket disconnected:", reason);
        });
    }

    return socket;
};

export const getSocket = (): Socket | null => socket;

export const disconnectSocket = (): void => {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
};